var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckBoxFilled = function SvgCheckBoxFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71717A",
    fillRule: "evenodd",
    d: "M7.975 1.333h.05c.91 0 1.628 0 2.209.04.592.04 1.09.124 1.552.316a4.667 4.667 0 0 1 2.525 2.525c.192.462.276.96.316 1.552.04.58.04 1.298.04 2.21v.049c0 .91 0 1.628-.04 2.209-.04.592-.124 1.09-.316 1.552a4.667 4.667 0 0 1-2.525 2.525c-.463.192-.96.276-1.552.316-.58.04-1.298.04-2.21.04h-.049c-.91 0-1.629 0-2.21-.04-.59-.04-1.089-.124-1.55-.316a4.667 4.667 0 0 1-2.527-2.525c-.191-.462-.275-.96-.315-1.552-.04-.58-.04-1.298-.04-2.21v-.049c0-.91 0-1.628.04-2.209.04-.592.124-1.09.315-1.552A4.667 4.667 0 0 1 4.214 1.69c.462-.192.96-.276 1.552-.316.58-.04 1.298-.04 2.21-.04Zm2.734 5.782a.667.667 0 1 0-.752-1.101l-.067.046a10.656 10.656 0 0 0-2.783 2.778l-.97-.968a.667.667 0 0 0-.942.943l1.561 1.56a.667.667 0 0 0 1.05-.141 9.323 9.323 0 0 1 2.836-3.071l.067-.046Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckBoxFilled);
export default ForwardRef;